// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xHDI","top":"styles_top__14Rxo"};